import { useEffect } from 'react';
import Header from "./common/Header";
import Login from "./auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import { Toaster } from 'react-hot-toast';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import MenuView from "./MenuView";
import { menu } from "./config/constant";
import { initGoogleAnalytics } from './common/gtag';

function App() {
  const location = useLocation();

  useEffect(() => {
    // On initial app load: try to get user from localStorage (if already logged in)
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const userId = storedUser?.id;
    initGoogleAnalytics(userId); // send user_id if available
  }, []);

  if (location.pathname === "/login") {
    return <Login />;
  }

  return (
    <>
      <Header />
      <div className="h-[calc(100vh-68px)] mobile:h-auto">
        <Toaster position="top-center" reverseOrder={false} />
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/*" element={<MenuView menu={menu} />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
